import React from 'react';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import { buildTools } from '../../data/site';
export function BuiltWith() {
  return <section aria-label="Tools and platforms we build on" className="border-y border-hairline bg-canvas py-10" data-id="element-440" data-mp="3t37p08pzoc9m">
      <Container data-id="element-441" data-mp="3j2nl0yb34tnp">
        <Reveal className="flex flex-col gap-6 lg:flex-row lg:items-center lg:gap-14" data-id="element-442" data-mp="3j36zg51j0zwz">
          <p className="shrink-0 text-small text-muted" data-id="element-443" data-mp="kks05s0y0h9a">Built with</p>
          <div className="built-with-marquee relative min-w-0 flex-1 overflow-hidden" data-id="element-444" data-mp="kn4dfrvra3g0">
            <div className="built-with-track flex w-max whitespace-nowrap" data-id="element-445" data-mp="fmqgb4vp0dwr">
              {[0, 1].map(group => <ul key={group} className="flex shrink-0 items-center gap-x-10 pr-10 lg:gap-x-14 lg:pr-14" aria-hidden={group === 1} data-id="element-446" data-mp="asvrjn18d8qt">
                  {buildTools.map(tool => <li key={`${group}-${tool}`} className="built-with-item text-[18px] font-medium tracking-[-0.02em] text-ink" data-id="element-447" data-mp="13cucwsagrde9">
                      {tool}
                    </li>)}
                </ul>)}
            </div>
            <span aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 z-10 w-[120px] bg-gradient-to-r from-canvas to-transparent" data-id="element-448" data-mp="23r4pqb7vpmde" />
            <span aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 z-10 w-[120px] bg-gradient-to-l from-canvas to-transparent" data-id="element-449" data-mp="28owpfrermcs5" />
          </div>
        </Reveal>
      </Container>
    </section>;
}